import { combineReducers } from 'redux';
import stack from './stacks.reducer';

const reducer = combineReducers({
	stack
});

export default reducer;
